import { Container, Section } from '@/components/common';
import { routes } from '@/config/routes';
import { useDocumentMetadata } from '@/hooks/useDocumentMetadata';

import { Link } from 'react-router-dom';

export function NotFoundPage() {
  useDocumentMetadata('Page Not Found');
  return (
    <Section spacing="large">
      <Container size="narrow">
        <div className="state-card">
          <span className="state-card__code">404</span>
          <h1>Page not found</h1>
          <p>The page you requested may have moved or is not available yet.</p>
          <Link className="button-link button-link--primary" to={routes.home}>
            Return home
          </Link>
        </div>
      </Container>
    </Section>
  );
}
